import { v4 as uuidv4 } from "uuid";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { ROLE } from "./commonConstant";
import { fetchFromWebApi } from './fetchFromWebApi';
import axiosInstanceInterceptor from "./axiosInstanceInterceptor";
import { getOrRefreshBearerToken } from "../services/bearerToken.service";
import { API_VERSION } from "./commonConstant";

export const getS3Url = async (fileName) => {
  try {
    const res = await fetch(
      `https://s5a26rvza4jr333q7wugsfkega0gurkl.lambda-url.eu-west-2.on.aws`,
      {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify({ filename: fileName }),
      }
    );
    const resultURL = await res.json();
    return resultURL;
  } catch (err) {
    console.error("Error fetching the S3 URL:", err);
  }
};

export const generatePdf = async (elementRef) => {
  const element = elementRef.current;
  const canvas = await html2canvas(element, { scale: 2 });
  const data = canvas.toDataURL("image/jpeg", 0.5);
  const pdf = new jsPDF("p", "mm", "a4");
  const imgProperties = pdf.getImageProperties(data);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

  let position = 0;
  let remainingHeight = pdfHeight;

  while (remainingHeight > 0) {
    pdf.addImage(
      data,
      "JPEG",
      0,
      position,
      pdfWidth,
      pdfHeight,
      undefined,
      "FAST"
    );
    remainingHeight -= pdf.internal.pageSize.getHeight();
    position -= pdf.internal.pageSize.getHeight();
    if (remainingHeight > 0) {
      pdf.addPage();
    }
  }

  const fileUniqueName = `hhcontractsigned_${uuidv4()}.pdf`;
  const pdfBlob = pdf.output("blob");

  return { pdfBlob, fileUniqueName };
};

export const downloadPdfPreview = async () => {
  const input = document.getElementById('paperToPrint');
  html2canvas(input, { scale: 2 })
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png', 0.5);
      const pdf = new jsPDF("p", "pt", "a4");
      const imgProperties = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

      let position = 0;
      let remainingHeight = pdfHeight;

      while (remainingHeight > 0) {
        pdf.addImage(
          imgData,
          "JPEG",
          0,
          position,
          pdfWidth,
          pdfHeight,
          undefined,
          "FAST"
        );
        remainingHeight -= pdf.internal.pageSize.getHeight();
        position -= pdf.internal.pageSize.getHeight();
        if (remainingHeight > 0) {
          pdf.addPage();
        }
      }
      // pdf.output('dataurlnewwindow');
      pdf.save("download.pdf");
    })
    ;
}

export const uploadPdfToS3 = async (pdfBlob, fileName) => {
  try {
    const { uploadUrl, downloadUrl } = await getS3Url(fileName);
    const resUpload = await fetch(uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": "application/pdf" },
      body: pdfBlob,
    });
    if (resUpload?.ok) {
      console.log("PDF uploaded successfully!");
    } else {
      console.error("Failed to upload PDF to S3.");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};

export const fetchFormData = async (
  clientId,
  documentType,
  subcotractorTypeId,
  notificationScheduleId
) => {
  try {
    const res = await fetchFromWebApi(
      `HHContractSignDocument/GetHHContractSignSubcontractorDocument?clientId=${clientId}&subcontractorTypeId=${subcotractorTypeId}&notificationSequence=${documentType}&notificationScheduleId=${notificationScheduleId}`,
      {
        method: "GET"
      }
    );
    if (res?.status === 401) {
      getRedirectUrl();
    } else if (res?.ok) {
      const json = await res.json();
      console.log("Form GetActiveHHContractstByClientId:", json);
      return json;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const fetchSubContractorDetail = async (clientId, subcontractorId) => {
  try {
    const res = await fetchFromWebApi(
      `Subcontractor/GetSubcontractorDetails?subcontractorId=${subcontractorId}&clientId=${clientId}`,
      {
        method: "GET"
      }
    );
    if (res?.ok) {
      const json = await res.json();
      console.log("Subcontractors fetched successfully:", json);
      return json;
    } else {
      console.error("Failed to fetch subcontractor details:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching subcontractor details:", error);
  }
};

export const mergeElementsWithFormValues = (elements, formElementValues) => {
  // console.log(formElementValues,"formElementValues")
  // console.log(elements,"elementselements")
  const formElementValuesMap = new Map(
    formElementValues.map((item) => [item.elementId, item])
  );
  // console.log(formElementValuesMap,"formElementValuesMap")
  return elements.map((element) => {
    if (element.type === "horizontalContainer") {
      console.log(element.items, "ElementItems");
      if (element.items) {
        element.items.map((item) => {
          const updatedItem = formElementValuesMap.get(item.id);
          // console.log(updatedItem,'updatedItem')
          if (updatedItem) {
            if (item.type !== "signature") {
              item.props = updatedItem;
            } else {
              item.props = { ...updatedItem, disabled: false };
            }
          }
          // console.log(item.props,"ItemProps")
        });
      }
    }
    const updatedElement = formElementValuesMap.get(element.id);
    if (updatedElement) {
      if (element.type !== "signature") {
        element.props = updatedElement;
      } else {
        element.props = { ...updatedElement, disabled: false };
      }
    }
    return element;
  });
};

export const fetchSubcontractorTypeData = async (clientId) => {
  try {
    const res = await fetchFromWebApi(
      `Subcontractor/GetSubcontractorType?clientId=${clientId}`,
      {
        method: "GET"
      }
    );
    if (res?.ok) {
      const result = await res.json();
      return result;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const fetchClientDetailData = async (clientId) => {
  try {
    const res = await fetchFromWebApi(
      `Client/GetClientDetailById?clientId=${clientId}`,
      {
        method: "GET"
      }
    );
    if (res?.status === 401) {
      getRedirectUrl();
    } else if (res?.ok) {
      const result = await res.json();
      return result;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const fetchContractsData = async (clientId) => {
  try {
    const res = await fetchFromWebApi(
      `HHContract/GetActiveHHContractstByClientId?clientId=${clientId}`,
      {
        method: "GET"
      }
    );
    if (res?.status === 401) {
      getRedirectUrl();
    } else if (res?.ok) {
      const json = await res.json();
      return json;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const fetchAllClients = async () => {
  try {
    const res = await fetchFromWebApi(
      `Client/GetAllClients`,
      {
        method: "GET"
      }
    );
    if (res?.status === 401) {
      getRedirectUrl();
    } else if (res?.ok) {
      const result = await res.json();
      return result;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};


export const fetchClientDetails = async (clientId) => {
  try {
    const res = await fetchFromWebApi(
      `Client/GetClientDetailById?clientId=${clientId}`,
      {
        method: "GET"
      }
    );
    if (res?.status === 401) {
      getRedirectUrl();
    } else if (res?.ok) {
      const json = await res.json();
      return json;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const processParagraphText = (
  text,
  inlineFields,
  subcontractorAndClientDetail,
  fieldMappings
) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");

  inlineFields.forEach((inlineField) => {
    const detailKey = fieldMappings[inlineField.mappingField];
    if (detailKey) {
      const newValue = subcontractorAndClientDetail[detailKey] || "";

      const element = doc.querySelector(`[data-uuid="${inlineField.uuid}"]`);
      if (element) {
        element.setAttribute("data-default-value", newValue);
      }
      inlineField.value = newValue;
    }
  });

  return doc.body.innerHTML;
};

export const processElement = (
  element,
  subcontractorAndClientDetail,
  fieldMappings
) => {
  if (element.type === "paragraph" && element.props.inlineFields?.length > 0) {
    const updatedText = processParagraphText(
      element.props.text,
      element.props.inlineFields,
      subcontractorAndClientDetail,
      fieldMappings
    );

    return {
      ...element,
      props: {
        ...element.props,
        text: updatedText,
        inlineFields: element.props.inlineFields,
      },
    };
  }

  if (element.type === "textField") {
    const detailKey = fieldMappings[element.props.selectedField];
    if (detailKey) {
      return {
        ...element,
        props: {
          ...element.props,
          value: subcontractorAndClientDetail[detailKey] || element.props.value,
        },
      };
    }
  }

  return element;
};

export const fetchHHContractSignDocumentByClientId = async (clientId) => {
  try { 
    const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}${API_VERSION}`;
    let bearerToken = await getOrRefreshBearerToken();
    const response = await axiosInstanceInterceptor.get(
      `${API_BASE_URL}HHContractSignDocument/GetHHContractSignDocuments?clientId=${clientId}`,
      {
        headers: {
          "Authorization": `Bearer ${bearerToken}` // Add the token here
          // "Content-Type": "application/json", // Optional, if required by the API
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchHHAuditHistory = async (contractVersionId) => {
  try { 
      const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}${API_VERSION}`;
    let bearerToken = await getOrRefreshBearerToken();
    const response = await axiosInstanceInterceptor.get(
      `${API_BASE_URL}HHAuditTrial/GetHHAuditTrialByVersion?contractVersionId=${contractVersionId}`,
      {
        headers: {
          "Authorization": `Bearer ${bearerToken}` // Add the token here
          // "Content-Type": "application/json", // Optional, if required by the API
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const processParaElementAttr = (
  element,
  role,
  isShowTrackHistory = false,
  isResetAttrss = false
) => {
  if (element.type !== "paragraph" || !element.props.trackHistorys) {
    return element;
  }

  const updateElementAttributes = (trackChangeElement) => {
    const { actionType, changeType, hidden, status, actionBy, visibilityFor } =
      trackChangeElement.dataset;

    const actionByArray = actionBy?.split(",").map((item) => item.trim()) || [];
    // const visibilityArray =
    //   visibilityFor?.split(",").map((item) => item.trim()) || [];

    // Reset visibility condition
    // if (isResetAttrss) {
    //   if (
    //     visibilityArray.length &&
    //     !visibilityArray.includes(role) &&
    //     actionType === "Created"
    //   ) {
    //     trackChangeElement.setAttribute("data-hidden", " ");
    //   }
    //   return;
    // }

    // Show all track history
    if (isShowTrackHistory) {
      trackChangeElement.setAttribute("data-hidden", " ");
      return;
    } else {
      if (role !== ROLE.ADMIN) {
        const isActionByOther =
          actionByArray.length && !actionByArray.includes(role);
        const isAcceptedOrRejected = ["accepted", "rejected"].includes(
          actionType
        );

        if (isActionByOther && isAcceptedOrRejected) {
          trackChangeElement.setAttribute("data-hidden", " ");
        }
      }
    }

    // Hide logic for non-admin roles
    // if (role !== ROLE.ADMIN) {
    //   const isActionByOther = actionByArray.length && !actionByArray.includes(role);
    //   const isAcceptedOrRejected = ["accepted", "rejected"].includes(actionType);

    //   if (isActionByOther && isAcceptedOrRejected) {
    //     trackChangeElement.setAttribute("data-hidden", " ");
    //     // trackChangeElement.setAttribute("data-status", "Created");
    //   }

    // if (
    //   visibilityArray.length &&
    //   !visibilityArray.includes(role) &&
    //   ["Created", "accepted", "rejected"].includes(actionType)
    // ) {
    //   // Handle CLIENT role
    //   if (role === USERROLE.CLIENT) {
    //     trackChangeElement.setAttribute("data-hidden", "false");
    //   }

    //   // Handle MARKEL role
    //   if (role === USERROLE.MARKEL) {
    //     const isAdded = changeType === TRACKCHANGE.CHANGETYPE.ADDED;
    //     const isDeleted = changeType === TRACKCHANGE.CHANGETYPE.DELETED;

    //     if (isAdded) {
    //       const hiddenValue = actionType === "accepted" ? "false" : actionType === "rejected" ? "true" : " ";
    //       trackChangeElement.setAttribute("data-hidden", hiddenValue);
    //     }

    //     if (isDeleted) {
    //       const hiddenValue = actionType === "rejected" ? "false" : actionType === "accepted" ? "true" : " ";
    //       trackChangeElement.setAttribute("data-hidden", hiddenValue);
    //     }
    //   }
    // }
  };

  const processParagraphTextsetAttr = (text) => {
    if (!text) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    doc.querySelectorAll(".track-changes").forEach(updateElementAttributes);

    return doc.body.innerHTML;
  };

  return {
    ...element,
    props: {
      ...element.props,
      text: processParagraphTextsetAttr(element.props.text),
    },
  };
};

export const processParaEnableDisableTrackHistory = (
  text,
  isTrackingHistoryEnabled = false
) => {
  const updateElementAttributes = (trackChangeElement) => {
    const { actionType, changeType, hidden, status, actionBy, visibilityFor } =
      trackChangeElement.dataset;

    // const actionByArray = actionBy?.split(",").map((item) => item.trim()) || [];

    // Show all track history
    if (isTrackingHistoryEnabled) {
      trackChangeElement.setAttribute("data-hidden", " ");
      return;
    } else {
      // Determine visibility only if tracking is disabled
      if (actionType !== "Created" && actionType) {
        const shouldBeHidden =
          (changeType === "added" && actionType === "rejected") ||
          (changeType === "deleted" && actionType === "accepted");

        trackChangeElement.setAttribute(
          "data-hidden",
          shouldBeHidden ? "true" : "false"
        );
      }
    }
  };

  const processParagraphTextsetAttr = (text) => {
    if (!text) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    doc.querySelectorAll(".track-changes").forEach(updateElementAttributes);

    return doc.body.innerHTML;
  };
  return processParagraphTextsetAttr(text);
};

export const processParaResetForNewContract = (text) => {
  const updateTrackElementAttributes = (trackChangeElement) => {
    ["data-action-type", "data-change-type", "data-hidden", "data-status", "data-action-by", "data-visibility-for"].forEach((attr) => {
      trackChangeElement.removeAttribute(attr);
    });
    trackChangeElement.classList.remove("track-changes");
  };

  const updateHighlightElementAttributes = (highlightElement) => {
    ["data-highlight-id", "data-comment-id", "data-has-comments", "data-highlight-status"].forEach((attr) => {
      highlightElement.removeAttribute(attr);
    });
    highlightElement.classList.remove("selection-highlight");
  };

  const processParagraphTextsetAttr = (text) => {
    if (!text) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    const trackChangeElements = doc.querySelectorAll(".track-changes");
    if (trackChangeElements.length > 0) {
      trackChangeElements.forEach(updateTrackElementAttributes);
    }
    const hightlightElements = doc.querySelectorAll(".selection-highlight");
    if (hightlightElements.length > 0) {
      hightlightElements.forEach(updateHighlightElementAttributes);
    }

    return doc.body.innerHTML;
  };
  return processParagraphTextsetAttr(text);
};


export const processHighlightRemovePara = (element, role) => {
  if (element.type !== "heading" && element.type !== "paragraph")
    return element;

  const HIGHLIGHT_PLUGIN_ATTRIBUTES = [
    "data-highlight-id",
    "data-comment-id",
    "data-has-comments",
    "data-highlight-status",
  ];

  const updateTrackElementAttributes = (el) => {
    const { actionType, changeType } = el.dataset;

    if (actionType === "Created") {
      el.setAttribute("data-hidden", "false");
      return;
    }

    if (actionType) {
      const shouldHide =
        (changeType === "added" && actionType === "rejected") ||
        (changeType === "deleted" && actionType === "accepted");
      el.setAttribute("data-hidden", shouldHide ? "true" : "false");
    }
  };

  const updateHighlightElementAttributes = (el) => {
    HIGHLIGHT_PLUGIN_ATTRIBUTES.forEach((attr) => el.removeAttribute(attr));
  };

  const processTextContentForPresentMode = (htmlText) => {
    if (!htmlText) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");

    doc
      .querySelectorAll(".track-changes")
      .forEach(updateTrackElementAttributes);
    doc
      .querySelectorAll(".selection-highlight")
      .forEach(updateHighlightElementAttributes);

    return doc.body.innerHTML;
  };

  return {
    ...element,
    props: {
      ...element.props,
      text: processTextContentForPresentMode(element.props.text),
    },
  };
};

export const getRedirectUrl = () => {
  const baseUrl = window.location.origin;
  const redirectUrl = `${baseUrl}/home`;
  const loginUrl = `${process.env.REACT_APP_BASE_API_URL}/Auth/HHPortal?hhredirect=${encodeURIComponent(redirectUrl)}`;
  window.location.href = loginUrl;
}